
import {map} from 'rxjs/operators';
import {Component} from '@angular/core';
import {AngularTokenService} from '@lakshvairav/angular-token';
import {Router} from '@angular/router';
import {AuthorizationService} from '../../../shared/authorization.service';
import {KeyValue} from '../../../shared/key-value';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'help-popup-contact',
  templateUrl: 'help-popup-contact.component.html',
  styleUrls: ['./help-popup-contact.component.css']
})

export class HelpPopupContactComponent {
  contact_session = [];
constructor(private router: Router, private _tokenService: AngularTokenService,
public authService: AuthorizationService, private KeyValueService: KeyValue) {
  this.authService.get(KeyValue.api_modify_session_index).pipe(
    map(res => res)).subscribe(
      data => {
        this.contact_session = data.contactsession;
      });

}

}
